import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { NguCarousel, NguCarouselConfig } from "@ngu/carousel";
import { FileUploadService } from "src/app/domain/services/file-uploader.service";

@Component({
	selector: "app-home-carousel",
	templateUrl: "./home-carousel.component.html",
	styleUrls: ["./home-carousel.component.scss"]
})
export class HomeCarouselComponent {
	name = "Angular";
	slideNo = 0;
	withAnim = true;
	resetAnim = true;

	@ViewChild("myCarousel") myCarousel: NguCarousel<any>;
	carouselConfig: NguCarouselConfig = {
		grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
		load: 3,
		interval: { timing: 4000, initialDelay: 1000 },
		loop: true,
		touch: true,
		velocity: 0.2
	};
	carouselItems = [];

	constructor(
		private cdr: ChangeDetectorRef,
		private uploadService: FileUploadService
	) {}

	ngAfterViewInit() {
		this.cdr.detectChanges();
	}

	ngOnInit() {
		this.uploadService.getHomeFiles().subscribe(r => {
			r.data.forEach(element => {
				if (window.matchMedia("(min-width: 768px)").matches) {
					const char0 = element.bannerDesktop.banner.charAt(0);
					let stringImgType;
					char0 === "/" ? (stringImgType = "jpg") : "";
					char0 === "i" ? (stringImgType = "png") : "";
					this.carouselItems.push({
						data: `data:image/${stringImgType};base64,` + element.bannerDesktop.banner,
						link: element.bannerDesktop.link
					});
				} else {
					const char0 = element.bannerMobile.banner.charAt(0);
					let stringImgType;
					char0 === "/" ? (stringImgType = "jpg") : "";
					char0 === "i" ? (stringImgType = "png") : "";
					this.carouselItems.push({
						data: `data:image/${stringImgType};base64,` + element.bannerMobile.banner,
						link: element.bannerMobile.link
					});
				}
			});
		});
	}

	reset(): void {
		this.myCarousel.reset(!this.resetAnim);
	}

	redirectTo(link): void {
		if (link) {
			const idx = link.indexOf("http://");
			const idxHttps = link.indexOf("https://");
			if (idx !== -1 || idxHttps !== -1) {
				window.open(link, "_blank").focus();
			} else {
				const newLink = "https://" + link;
				window.open(newLink, "_blank").focus();
			}
		}
	}

	moveTo(slide): void {
		this.myCarousel.moveTo(slide, !this.withAnim);
	}
}
